'use strict'

import { format } from 'date-fns';

import zonedDate from '../utils/zoned-date';
import { getModeOfSale } from '../utils/cookies';
import { publicGet } from '../utils/m2';

const now = zonedDate();

// const PERFORMANCE_TYPE_CATEGORY_ID = 8;
// const KEYWORDS_CATEGORY_ID = 6;

let _performancesPromise;
let _eventsPromise;

export function getEventData() {
    if (_eventsPromise) {
        return _eventsPromise;
    }

    const params = {
        urlParams: {
            modeOfSale: getModeOfSale(),
            stage: window.AppConfig.stage.toLowerCase(),
        },
    }

    _eventsPromise = publicGet('event-feed/{modeOfSale}/{stage}', params).then(response => {
        return response.data;
    }).catch(error => {
        console.error(error);
        return [];
    });

    return _eventsPromise;
}

export function getPerformances(listType) {
    return getAllPerformances().then(performances => {
        return performances.filter(perf => {
            if (listType === 'Events Only') {
                return perf.IsTour === false;
            }

            if (listType === 'Tours Only') {
                return perf.IsTour === true;
            }

            return true;
        });
    });
}

export function getAllPerformances() {
    if (_performancesPromise) {
        return _performancesPromise;
    }

    return _performancesPromise = getEventData().then(data => {
        return data.map(perf => {
            perf.UniqueID = perf.PerformanceNumber ? perf.PerformanceNumber : `CMS${perf.ID}`;

            perf.StartDate = perf.StartDate ? zonedDate(perf.StartDate) : null;
            perf.ListUntil = perf.ListUntil ? zonedDate(perf.ListUntil) : null;
            perf.EndDate = perf.EndDate ? zonedDate(perf.EndDate) : null;
            perf.PerformanceDate = perf.PerformanceDate ? zonedDate(perf.PerformanceDate) : null;
            perf.StartSaleDate = perf.StartSaleDate ? zonedDate(perf.StartSaleDate) : null;
            perf.EndSaleDate = perf.EndSaleDate ? zonedDate(perf.EndSaleDate) : null;

            perf.DateString = format(perf.PerformanceDate, 'yyyy-MM-dd');

            perf.Day = format(perf.PerformanceDate, 'EEE');
            perf.Date = format(perf.PerformanceDate, 'd');
            perf.Month = format(perf.PerformanceDate, 'MMM');
            perf.Time = format(perf.PerformanceDate, 'h:mm aaa');

            perf.HasAvailability = perf.Availability > 0;

            let venue = perf.Venue || perf.Facility;

            if (venue) {
                perf.Venue = venue;
            }

            perf.TicketLink = null;

            if (perf.CustomBookingURL) {
                perf.TicketLink = perf.CustomBookingURL;
            } else if (perf.PerformanceNumber) {
                perf.TicketLink = `${window.AppConfig.performanceBookingBaseUrl}/${perf.PerformanceNumber}`;
            }

            let type = perf.PerformanceType ? [perf.PerformanceType] : null;

            const keywords = perf.Keywords || {};

            perf.Filters = {
                Type: type ? type : [],
                Venue: venue ? [venue] : [],
                Keywords: keywords,
            }

            return perf;
        }).filter(perf => {
            return perf.PerformanceDate > now;
        }).sort((a, b) => {
            return a.PerformanceDate - b.PerformanceDate;
        });
    })
}

const _calendarDataCache = new Map();
export function getCalendarData(listType) {
    if (_calendarDataCache.has(listType)) {
        return _calendarDataCache.get(listType);
    }

    const now = zonedDate();
    const promise = getPerformances(listType).then(perfs => {
        const yearData = perfs.reduce((carry, perf) => {
            const year = format(perf.PerformanceDate, 'yyyy');
            const monthName = format(perf.PerformanceDate, 'MMMM');
            const month = format(perf.PerformanceDate, 'M');

            let yearDataItem = carry.find(item => {
                return item.Name === year;
            });

            if (!yearDataItem) {
                yearDataItem = {
                    Name: year,
                    Order: parseInt(year, 10),
                    Months: [],
                };

                carry.push(yearDataItem)
            }

            let monthData = yearDataItem.Months.find(item => {
                return item.Name === monthName;
            });

            if (!monthData) {
                monthData = {
                    Name: monthName,
                    Order: parseInt(month, 10),
                    Performances: [],
                }

                yearDataItem.Months.push(monthData);
            }

            perf.IsOnSale = perf.StartSaleDate < now && now < perf.EndSaleDate;
            monthData.Performances.push(perf);

            return carry;
        }, []);

        return {
            yearData: yearData,
            totalCount: perfs.length,
        };
    });

    _calendarDataCache.set(listType, promise);
    return promise;
}
